import curry from "../../../../lib/core/functional/curry";

export function validatePasswordConfirmation(form) {
    const { elements } = form;

    const password = elements["password"];
    const confirm_password = elements["confirm_password"];

    if (password.value === confirm_password.value) return true;

    const errorMessageEvent = new CustomEvent("authentication:error", {
        detail: { message: "Your passwords don't match" },
    });

    form.dispatchEvent(errorMessageEvent);
    return false;
}

function handleEventPropagation(element, validator, event) {
    if (validator(element)) return;

    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
}

const preparePropagationHandler = curry(handleEventPropagation);

export function addSubmitValidator(form, validator) {
    form.addEventListener("submit", preparePropagationHandler(form, validator), true);
}
